<svg [attr.width]="width" [attr.height]="height" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M14.25 3C14.25 4.24264 11.2279 5.25 7.5 5.25C3.77208 5.25 0.75 4.24264 0.75 3M14.25 3C14.25 1.75736 11.2279 0.75 7.5 0.75C3.77208 0.75 0.75 1.75736 0.75 3M14.25 3V13.5C14.25 14.745 11.25 15.75 7.5 15.75C3.75 15.75 0.75 14.745 0.75 13.5V3M14.25 6.54016C14.25 7.78516 11.25 8.79016 7.5 8.79016C3.75 8.79016 0.75 7.78516 0.75 6.54016M14.25 10.08C14.25 11.325 11.25 12.33 7.5 12.33C3.75 12.33 0.75 11.325 0.75 10.08"
    stroke="var(--stroke-color)"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
